<template>
  <div>
    <v-alert
      :type="typeClass"
      dismissible
    >
    {{ notification.message }}
    </v-alert>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["notification"],

  data() {
    return {
      timeout: null
    };
  },

  computed: {
    typeClass() {
      return `${this.notification.type}`;
    }
  },

  created() {
    this.timeout = setTimeout(() => {
      this.removeNotification(this.notification);
    }, 10000);
  },

  beforeDestroy() {
    clearTimeout(this.timeout);
  },

  methods: mapActions(["removeNotification"])
};
</script>